import styled from '@emotion/styled';

export const Container = styled.div`
  .ant-card-cover {
    img {
      height: 200px;
      width: 100%;
      object-fit: cover;
    }
  }
  .ant-alert {
    font-size: 12px;
  }
  .ant-menu {
    margin-bottom: 10px;
  }
  .ant-list-item-content {
    flex: 1;
  }
`;

export const OrderItem = styled.div`
  flex: 1;
  h4 {
    margin-bottom: 10px;
  }
  .tnx {
    display: flex;
    margin-bottom: 15px;
    .details {
      margin-left: 10px;
      p {
        margin-bottom: 5px;
      }
    }
  }
`;

export const Search = styled.div`
  display: flex;
  margin-bottom: 10px;
  .ant-input-search {
    margin-left: auto;
    max-width: 500px;
  }
`;